import React from "react";

const KeepItFunTopBGElement = () => {
  return (
    <svg
      width="68"
      height="84"
      viewBox="0 0 68 84"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_6476_35648)">
        <path
          d="M0 -40H56V44C56 59.464 43.464 72 28 72C12.536 72 0 59.464 0 44V-40Z"
          fill="white"
          fillOpacity="0.04"
        />
        <path
          d="M12 -28H68V56C68 71.464 55.464 84 40 84C24.536 84 12 71.464 12 56V-28Z"
          fill="white"
          fillOpacity="0.04"
        />
      </g>
      <defs>
        <clipPath id="clip0_6476_35648">
          <rect width="68" height="84" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default KeepItFunTopBGElement;
